import { useEffect, useRef } from "react";

import useAuthData from "@modules/auth/hooks/useAuthData";
import { pushBeginCheckout } from "@modules/gtm";

import { OrderFields } from "../../constants";
import useOrderFormik from "../useOrderFormik";

const useBeginCheckoutEvent = (): void => {
  const { values } = useOrderFormik();
  const [authData] = useAuthData();
  const hasFired = useRef(false);

  const price = values[OrderFields.PRICE];

  useEffect(() => {
    if (hasFired.current || price == null) {
      return;
    }

    pushBeginCheckout(values, { email: authData?.email, phone: authData?.phone });
    hasFired.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [price]);
};

export default useBeginCheckoutEvent;

